enum StoreStatus {
  IDLE = 0,
  PENDING,
  SUCCESS,
  ERROR,
}

export default StoreStatus;
